export default "__VITE_ASSET__8ed82efa__"